'use client';

import { CircleUserRound } from 'lucide-react';
import { useTranslations } from 'next-intl';
import Link from 'next/link';

import { getPublicHref, ROUTE } from '@utils/route-utils';

/** Signed-out avatar fallback: LQD's own sign-in page, never Clerk's portal. */
function AppNavSigninButton() {
  const t = useTranslations();
  return (
    <Link
      href={getPublicHref([ROUTE.SIGN_IN])}
      aria-label={t('common.log-in')}
      className="inline-flex size-11 items-center justify-center rounded-full"
    >
      <CircleUserRound size={28} />
    </Link>
  );
}

export default AppNavSigninButton;
